module.exports = __webpack_public_path__ + "static/img/time-line-red.a77da20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/red-about/time-line-red.png
// module id = 1059
// module chunks = 173